import React from 'react';
import { Stack, Text } from '@moda/om';
import { ReturnPolicy } from '../../generated/types/globalTypes';
import { ReturnPolicyIcon } from './ReturnPolicyIcon';

interface Props {
  returnPolicy: ReturnPolicy;
  promoCodeApplied: boolean;
}

export const LineItemReturnPolicyHeader: React.FC<Props> = ({ returnPolicy, promoCodeApplied }) => (
  <Stack className="LineItemReturnPolicyHeader" direction="horizontal" space={2}>
    <ReturnPolicyIcon returnPolicy={returnPolicy} />

    <Text treatment="body1"> {promoCodeApplied ? 'Updated' : ''} Return Policy </Text>
  </Stack>
);
